import type { FaireBrandEntity } from "@faire/playground-entity-db/entity_types/brand";
import { getEntityByToken } from "../get_entity";

import { products } from "./products";

const BRAND_TOKENS = [
  "astoria-granola-co",
  "b_cec2e9ck5e",
  "b_elccldtdr7",
  "b_matxbn4vdk",
  "brooklyn-cookie-co",
  "brooklyn-soap-works",
  "catalog_brand_abbott",
  "catalog_brand_audreys_home_gift",
  "catalog_brand_roen",
  "casa-bosques",
  "caden-lane",
  "driftless-studios",
  "fine-raw-chocolate",
  "homemade-ish",
  "hudson-valley-candles",
  "manhattan-snack-co",
  "oskro",
  "potluck",
  "queens-beverage-co",
  "sweet-wink",
  "toysmith",
  "viverano-organics",
  "williamsburg-home",
];

const brandEntities = BRAND_TOKENS.map((token) =>
  getEntityByToken(token, "brand")
).filter(
  (brand: FaireBrandEntity | undefined): brand is FaireBrandEntity =>
    brand !== undefined
);

export const brands: FaireBrandEntity[] = brandEntities.map((brand) => ({
  ...brand,
}));

export const getBrandById = (brandId: string): FaireBrandEntity | undefined => {
  return brands.find((brand) => brand.token === brandId);
};

export const getBrandByName = (
  brandName: string
): FaireBrandEntity | undefined => {
  return brands.find((brand) => brand.name === brandName);
};

export const getBrandBySlug = (slug: string): FaireBrandEntity | undefined => {
  const normalizedSlug = slug.trim().toLowerCase();
  const fromBrands = brands.find((brand) => {
    const tokenSlug = brand.token.toLowerCase();
    const nameSlug = brand.name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
    return tokenSlug === normalizedSlug || nameSlug === normalizedSlug;
  });
  if (fromBrands) {
    return fromBrands;
  }

  // Backward-compatibility for legacy routes that key brands by slug-only
  // where canonical brand entities have not been imported yet.
  const matchingProducts = products.filter((product) => {
    const nameSlug = product.brandName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
    return nameSlug === normalizedSlug;
  });
  if (matchingProducts.length === 0) {
    return undefined;
  }

  const representative = matchingProducts[0];
  return {
    token: `brand_fallback_${normalizedSlug}`,
    type: "brand",
    name: representative.brandName,
    rating: 4.8,
    minimumOrderDollars: 100,
    meta: {
      source: "mock",
      importedAt: "2026-03-25T00:00:00.000Z",
      importedBy: "brand-slug-fallback",
    },
  };
};

export const getAllBrands = (): FaireBrandEntity[] => {
  return brands;
};
